import { createSafeStorage } from '../browserStorage';

export const sessionStorage = createSafeStorage('sessionStorage');
